import React, { useEffect, useState } from 'react';
//tabs
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useParams } from 'react-router-dom';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import Header from './Details/Header';
import Invoice from './Details/Invoice';
import Log from './Details/Log';
import Pdf from './Details/Pdf';
import Xml from './Details/Xml';
import { wsGet } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';

export default function ShoppingDetails() {
  const claseStyleTab = useStyleTabs();

  const { id } = useParams();
  const [notify, showNotify] = useToasty();

  const [value, setValue] = useState(0);
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const [buyDetail, setBuyDetail] = useState({});

  async function getBuyDetail() {
    let response = await wsGet('purch/purchase', id);
    if (response.success) setBuyDetail(response.data);
  }

  useEffect(() => {
    getBuyDetail();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <div className={claseStyleTab.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChangeTab}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label="Cabecera" {...indexTab(0)} />
              <Tab label="Factura" {...indexTab(1)} />
              {/* <Tab label="Log" {...indexTab(2)} /> */}
              <Tab label="PDF" {...indexTab(2)} />
              <Tab label="XML" {...indexTab(3)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Header
              idUrl={id}
              buyDetail={buyDetail}
              reload={getBuyDetail}
              showNotify={showNotify}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Invoice idUrl={id} buyDetail={buyDetail} showNotify={showNotify} reload={getBuyDetail} />
          </TabPanel>
          {/* <TabPanel value={value} index={2}>
            <Log
              idUrl={id}
              date={
                buyDetail.last_process_date
                  ? moment(buyDetail.last_process_date).format(
                      "DD-MM-YYYY, h:mm:ss a"
                    )
                  : ""
              }
              showNotify={showNotify}
            />
          </TabPanel> */}
          <TabPanel value={value} index={2}>
            <Pdf purchaseId={id} purchase={buyDetail} showNotify={showNotify} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Xml purchaseId={id} purchase={buyDetail} showNotify={showNotify} />
          </TabPanel>
        </div>
      </GridItem>
    </GridContainer>
  );
}
